import { render, staticRenderFns } from "./Kuluckamadde.vue?vue&type=template&id=25887298&scoped=true"
import script from "./Kuluckamadde.vue?vue&type=script&lang=js"
export * from "./Kuluckamadde.vue?vue&type=script&lang=js"
import style0 from "./Kuluckamadde.vue?vue&type=style&index=0&id=25887298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25887298",
  null
  
)

export default component.exports